import React from 'react';
import PropTypes from 'prop-types';
import OwnCompanyRelationSelect from '@/shared/components/input/OwnCompanyRelationSelect';
import RelationName from '@/shared/components/RelationName';
import FormGroupPart from './FormGroupPart';
import { relationShape } from '../registrationHelpers';
import messages from '../registrationMessages';

const OwnCompanyRelationFormGroup = ({
  relation,
  onChange,
  readOnly,
  disabled,
  autoFocus,
  userId,
}) => (
  <div className="form-group">
    <FormGroupPart label={messages.OwnCompany} inputCols="col-sm-10">
      {readOnly ? (
        <p className="form-control-static">
          {relation && <RelationName relation={relation} enabled={false} />}
        </p>
      ) : (
        <OwnCompanyRelationSelect
          onChange={onChange}
          value={relation}
          disabled={disabled}
          autoFocus={typeof autoFocus === 'undefined' ? !relation : autoFocus}
          userId={userId}
        />
      )}
    </FormGroupPart>
  </div>
);
OwnCompanyRelationFormGroup.propTypes = {
  relation: relationShape,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  userId: PropTypes.string,
};
OwnCompanyRelationFormGroup.defaultProps = {
  relation: null,
  onChange: () => {},
  readOnly: false,
  disabled: false,
  autoFocus: undefined,
  userId: undefined,
};
export default OwnCompanyRelationFormGroup;
